import(/* webpackMode: "eager" */ "/codebuild/output/src2340768698/src/apps/webapp/src/app/global-error.tsx");
